// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footerContent {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 80px 200px;
    background: black;
    color: white;
    width: 100%;
}

.footerContent .mainHeaderContent{
    width: 100%;
    display: flex;
    flex-direction: column;
}

.footerContent .headerContent{
    display: flex;
    flex-direction: row;
    width: 100%;
}

.footerContent .headerContent .header{
    display: flex;
    flex-direction: column;
    padding-right: 150px;
}

.footerContent .headerDescription{
    display: flex;
    flex-direction: row;
    white-space: pre-line;
    align-items: start;
    justify-content: space-between;
    width: 100%;
}

.footerContent .footerLinksContent{
    display: flex;
    flex-direction: row;
    align-items: start;
    margin-top: 20px;
    justify-content: space-between;
}

.footerContent .footerLinksContent a{
    color: white;
    text-align: center;
    font-weight: normal;
    padding-bottom: 5px;
}

.footerContent .footerLinksContent a:link { text-decoration: none; }

.footerContent .footerLinksContent a:visited { text-decoration: none; }

.footerContent .footerLinksContent a:hover { text-decoration: none; }

.footerContent .footerLinksContent a:active { text-decoration: none; }

.footerContent .footerLinksContent a:hover{
    cursor: pointer;
}

.footerContent .footerLinksContent .footerColumn{
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
}

.footerContent .footerLinksContent .footerColumn h1{
    color: #808080;
    font-size: 20px;
    margin-bottom: 20px;
}

.footerContent .allRightsReserved{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin: 60px 20px 0 20px;
    width: 100%;
    font-size: 14px;
}

.footerContent .allRightsReserved p{
    color: white;
    padding-bottom: 10px;
}

.footerContent .allRightsReserved p:hover{
    cursor: pointer;
}

.footerContent .allRightsReserved .links{
    display: flex;
    align-items: center;
    justify-content: center;
}

.footerContent .allRightsReserved .links a{
    margin: 0 20px;
}

@media (max-width: 767px) {
    .footerContent{
        padding: 80px 20px;
    }

    .footerContent .headerContent{
        flex-direction: column;
    }

    .footerContent .headerDescription{
        flex-direction: column;
    }

    .footerContent .footerLinksContent{
        flex-direction: column;
    }

    .footerContent .footerLinksContent .footerColumn h1{
        margin: 20px 0;
    }

    .footerContent .allRightsReserved{
        align-items: start;
        margin: 30px 20px 0 20px;
    }

    .footerContent .allRightsReserved .links a{
        margin: 0 20px 0 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/components/Footer/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,4CAA4C,qBAAqB,EAAE;;AAEnE,+CAA+C,qBAAqB,EAAE;;AAEtE,6CAA6C,qBAAqB,EAAE;;AAEpE,8CAA8C,qBAAqB,EAAE;;AAErE;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".footerContent {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding: 80px 200px;\n    background: black;\n    color: white;\n    width: 100%;\n}\n\n.footerContent .mainHeaderContent{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.footerContent .headerContent{\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n.footerContent .headerContent .header{\n    display: flex;\n    flex-direction: column;\n    padding-right: 150px;\n}\n\n.footerContent .headerDescription{\n    display: flex;\n    flex-direction: row;\n    white-space: pre-line;\n    align-items: start;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.footerContent .footerLinksContent{\n    display: flex;\n    flex-direction: row;\n    align-items: start;\n    margin-top: 20px;\n    justify-content: space-between;\n}\n\n.footerContent .footerLinksContent a{\n    color: white;\n    text-align: center;\n    font-weight: normal;\n    padding-bottom: 5px;\n}\n\n.footerContent .footerLinksContent a:link { text-decoration: none; }\n\n.footerContent .footerLinksContent a:visited { text-decoration: none; }\n\n.footerContent .footerLinksContent a:hover { text-decoration: none; }\n\n.footerContent .footerLinksContent a:active { text-decoration: none; }\n\n.footerContent .footerLinksContent a:hover{\n    cursor: pointer;\n}\n\n.footerContent .footerLinksContent .footerColumn{\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: start;\n}\n\n.footerContent .footerLinksContent .footerColumn h1{\n    color: #808080;\n    font-size: 20px;\n    margin-bottom: 20px;\n}\n\n.footerContent .allRightsReserved{\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    margin: 60px 20px 0 20px;\n    width: 100%;\n    font-size: 14px;\n}\n\n.footerContent .allRightsReserved p{\n    color: white;\n    padding-bottom: 10px;\n}\n\n.footerContent .allRightsReserved p:hover{\n    cursor: pointer;\n}\n\n.footerContent .allRightsReserved .links{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.footerContent .allRightsReserved .links a{\n    margin: 0 20px;\n}\n\n@media (max-width: 767px) {\n    .footerContent{\n        padding: 80px 20px;\n    }\n\n    .footerContent .headerContent{\n        flex-direction: column;\n    }\n\n    .footerContent .headerDescription{\n        flex-direction: column;\n    }\n\n    .footerContent .footerLinksContent{\n        flex-direction: column;\n    }\n\n    .footerContent .footerLinksContent .footerColumn h1{\n        margin: 20px 0;\n    }\n\n    .footerContent .allRightsReserved{\n        align-items: start;\n        margin: 30px 20px 0 20px;\n    }\n\n    .footerContent .allRightsReserved .links a{\n        margin: 0 20px 0 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
